export default function MathDuelIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <rect x="6" y="8" width="52" height="22" rx="5" fill="none" stroke="#3B434F" strokeWidth="3" />
      <path d="M15 19 h8 M19 15 v8 M30 16 l6 6 M36 16 l-6 6 M43 17 h8 M43 21 h8" stroke="#E7ECF3" strokeWidth="3" strokeLinecap="round" />
      <rect x="6" y="38" width="14" height="16" rx="3" fill="#2F8BFF" />
      <rect x="25" y="38" width="14" height="16" rx="3" fill="none" stroke="#3B434F" strokeWidth="3" />
      <rect x="44" y="38" width="14" height="16" rx="3" fill="#FF8A1F" />
    </svg>
  );
}
